import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { BillableServicesForecastSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  ModalWithItem,
  DragDropConfigExportTemplate,
} from '../../../../components/common';
import { tabelColumnExportBillableServicesForecast, sortBillableServicesForecast } from '../../constants';
import { getBillableServicesForecastReport, getAllBillableServicesForecastReport } from '../../actions';
import { makeGetListBillableServicesForecast, makeGetListAllBillableServicesForecast } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class BillableServicesForecast extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listBillableServicesForecast: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listBillableServicesForecast: props.listBillableServicesForecast,
      totalCount: getPageTotalCount({ ...state, items: props.listBillableServicesForecast }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetBillableServicesForecast },
    } = this.props;
    if (modeGetBillableServicesForecast) {
      this.doGetListBillableServicesForecast();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListBillableServicesForecast();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListBillableServicesForecast());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListBillableServicesForecast());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListBillableServicesForecast();
    });
  };

  doGetListBillableServicesForecast = () => {
    const { filter, page, size, sorted } = this.state;
    const { getBillableServicesForecastReport } = this.props;
    const newFilter = cloneDeep(filter);
    if (newFilter.invoiceExhibits) newFilter.invoiceExhibits = newFilter.invoiceExhibits === 'TRUE' ? 'true' : 'false';
    if (newFilter.unAssignedCutOff)
      newFilter.unAssignedCutOff = newFilter.unAssignedCutOff === 'TRUE' ? 'true' : 'false';
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortBillableServicesForecast[sorted.sortCol]
          ? sortBillableServicesForecast[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getBillableServicesForecastReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistBillableServicesForecast = cb => {
    const { filter, sorted } = this.state;
    const { getAllBillableServicesForecastReport } = this.props;
    const newFilter = cloneDeep(filter);
    if (newFilter.invoiceExhibits) newFilter.invoiceExhibits = newFilter.invoiceExhibits === 'TRUE' ? 'true' : 'false';
    if (newFilter.unAssignedCutOff)
      newFilter.unAssignedCutOff = newFilter.unAssignedCutOff === 'TRUE' ? 'true' : 'false';
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortBillableServicesForecast[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllBillableServicesForecastReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistBillableServicesForecast(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllBillableServicesForecast, t } = this.props;
        convertJson2Pdf({
          data: listAllBillableServicesForecast,
          t,
          title: t('reportPage:sidebar.billableServicesForecast').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.billableServicesForecast')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistBillableServicesForecast(() => {
      const { listAllBillableServicesForecast, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'BILLABLE_SERVICES_FORECAST_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.billableServicesForecast')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.billableServicesForecast')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllBillableServicesForecast,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { recurringUnit: 'recurringUnit', cutOffDOM: 'cutOffDOM' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllBillableServicesForecast,
          t,
          title: t('reportPage:sidebar.billableServicesForecast').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.billableServicesForecast')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.billableServicesForecast')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('BILLABLE_SERVICES_FORECAST_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportBillableServicesForecast,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listBillableServicesForecast,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllBillableServicesForecast,
      t,
      permissions: { modeGetBillableServicesForecast, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetBillableServicesForecast) return '';

    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.billableServicesForecast') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.billableServicesForecast')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <BillableServicesForecastSearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config ml-2"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.billableServicesForecast').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllBillableServicesForecast,
                          t,
                          title: t('reportPage:sidebar.billableServicesForecast').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.billableServicesForecast')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listBillableServicesForecast}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listBillableServicesForecast && listBillableServicesForecast.length
                      ? listBillableServicesForecast
                      : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

BillableServicesForecast.propTypes = {
  getBillableServicesForecastReport: PropTypes.func,
  getAllBillableServicesForecastReport: PropTypes.func,
  listAllBillableServicesForecast: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

BillableServicesForecast.defaultProps = {
  getBillableServicesForecastReport: () => {},
  getAllBillableServicesForecastReport: () => {},
  listAllBillableServicesForecast: [],
};

const mapStateToProps = createStructuredSelector({
  listBillableServicesForecast: makeGetListBillableServicesForecast() || [],
  listAllBillableServicesForecast: makeGetListAllBillableServicesForecast() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getBillableServicesForecastReport,
    getAllBillableServicesForecastReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(BillableServicesForecast)
);
